"use client";

import { useEffect, useState } from "react";
import { Row, Col, Card, Grid, Empty, message } from "antd";
import { Container, Button } from "react-bootstrap";
import Consultant_Header from "./Header";
import PatientSidebar from "./Consultant_sidebar";
import SectionManager from "./Section";
import DetailForm from "./DetailForm";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
  addConsultData,
  getCaseSheetData,
  getPreconsultData,
} from "../../services/doctor/consultant/consultant";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../services/authentication_API/authService";
import Loader from "../Loader";
import { getVitals } from "../../services/doctor/vitals/vitals";
import SectionManagerLi from "./SectionForLi";
import dayjs from "dayjs";
import { getPremedicalHistoryData } from "../../services/doctor/medical_history/medicalHistory";
import { useMessageApi } from "../../services/message api/MessageProvider";
import Vaccines from "../vaccination/Vaccines";
import VaccineBoard from "../vaccination/VaccineConsult";
const { useBreakpoint } = Grid;

export default function MedicalConsultation() {
  const location = useLocation();
  const { doctorID, appointmentID, activeSection, followUpAppointmentID } =
    location.state || {};
  console.log(
    "Doctor from state:",
    doctorID,
    appointmentID,
    activeSection,
    followUpAppointmentID
  );

  const { userData } = useAuth();

  const screens = useBreakpoint();
  const [currentactiveSection, setCurrentactiveSection] = useState(
    activeSection || null
  );

  const [appointmetDetails, setappointmentDetails] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});
  const [currentItem, setCurrentItem] = useState(null);
  const [currentItemRight, setCurrentItemRight] = useState(null);

  const [currentSection, setCurrentSection] = useState("symptoms");
  const [selectedIteamFormData, setSelectedIteamFormData] = useState({});
  const [showSectionList, setShowSectionList] = useState(true); // <-- NEW
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [vitalsData, setVitalsData] = useState(null);
  const [vitalRefreshFlag, setVitalRefreshFlag] = useState(false);
  const [preconsultDataRefresh, setPreconsultDataRefresh] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showHeader, setShowHeader] = useState(true);
  const [caseSheetData, setCaseSheetData] = useState([]);
  const [step, setStep] = useState("Symptoms");
  const messageApi = useMessageApi();

useEffect(() => {
  if (step !== "Treatment") return;

  let cancelled = false;

  const fetchPreMedicalHistory = async () => {
    try {
      const result = await getPremedicalHistoryData(data?.patient?.id);
      if (!result?.success || cancelled) return;

      const { consult_medical_histories } = result.data || {};

      let outputParts = [];

      consult_medical_histories?.forEach((category) => {
        if (category.medical_histories.length > 0) {
          // Format each item within the category
          const itemsString = category.medical_histories.map((item) => {
            let details = `<strong>${item.name}</strong>`;
            
            // Handle duration (Since 3-4 Years / 3-6 Months)
            if (item.since_year || item.since_month) {
              const timeStr = [
                item.since_year ? `${item.since_year} Years` : "",
                item.since_month ? `${item.since_month} Months` : ""
              ].filter(Boolean).join("-");
              details += `: since- ${timeStr}`;
            }
            if(item.since_when_year){
              details += `: since- ${item.since_when_year}`;
            }
            // Handle Family Relations
            if (item.family_relation) {
              details += `: ${item.family_relation}`;
            }

            return details;
          }).join(", ");

          // Clean up the Category Name (e.g., "H/O Medical Problems" -> "Medical Problems")
          const categoryTitle = category.name.replace("H/O ", "");
          outputParts.push(`<u>${categoryTitle}</u>: ${itemsString}`);
        }
      });

      if (outputParts.length === 0) return;

      // Join categories with line breaks
      const finalHtml = `${outputParts.join("<br/>")}`;

      messageApi.open({
        type: "info",
        content: (
          <div
            style={{
              color: "red",          // 🔴 Set to Red
              fontSize: "18px", 
              lineHeight: "1.8",
              fontWeight: "500",
              textAlign: "left"
            }}
            dangerouslySetInnerHTML={{ __html: finalHtml }}
          />
        ),
        duration: 8,
      });
    } catch (error) {
      console.error("Error fetching pre-medical history:", error);
    }
  };

  fetchPreMedicalHistory();
  return () => { cancelled = true; };
}, [step]);


  // 🔹 Handle scroll direction (for restoring header)
  const setSearchQueryfun = (value) => {
    console.log("search query ", searchQuery);
    setSearchQuery(value);
  };
  useEffect(() => {
    let lastScrollTop = 0;
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      // If user scrolls up -> show header and clear search
      if (scrollTop < lastScrollTop - 10) {
        setShowHeader(true);
        if (searchQuery.length > 0) setSearchQuery("");
      }

      // If user scrolls down OR active search -> hide header
      else if (scrollTop > lastScrollTop + 10 || searchQuery.length > 0) {
        setShowHeader(false);
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [searchQuery]);

  useEffect(() => {
    const fetchData = async () => {
      if (appointmentID) {
        try {
          let result = await getVitals(
            followUpAppointmentID ? followUpAppointmentID : appointmentID
          );
          console.log("Fetched Vitals Data:", result);

          if (result?.success) {
            setVitalsData(result?.data || null);
          } else {
            setVitalsData(null);
          }
        } catch (error) {
          console.error("Error fetching vitals:", error);
        }
      }
    };

    fetchData();
  }, [vitalRefreshFlag]);

  const sections = [
    "symptoms",
    "findings",
    "diagnosis",
    "medicines",
    "investigations",
    "instructions",
    "procedures",
  ];
  const goToNextSection = () => {
    //   const currentIndex = sections.indexOf(currentactiveSection);
    // if (currentIndex < sections.length - 1) {
    //     console.log("next section called")
    //    setCurrentactiveSection(sections[currentIndex + 1]);
    // } else {
    //   // Already at last section
    //   console.log("")
    //   setCurrentactiveSection(sections[0]); // or keep it same if you prefer
    // }
    setCurrentItem(null);
    setCurrentItemRight(null);
  };

  const handleDataChange = (section, name, newAttributes) => {
    console.log(
      `Form data changed: section=${section}, index=${name}`,
      newAttributes
    );

    setFormData((prev) => ({
      ...prev,
      [section]: prev[section].map((item, i) =>
        item?.name === name ? { ...item, ...newAttributes } : item
      ),
    }));
    setSelectedItem((prev) => ({
      ...prev,
      [section]: prev[section].map((item, i) =>
        item?.name === name ? { ...item, ...newAttributes } : item
      ),
    }));
  };
  const [showSidebar, setShowSidebar] = useState(false);
  const setshowSidebar = () => {
    setShowSidebar(false);
  };
  // const [formData, setFormData] = useState({
  //   appointment_id: appointmentID,
  //   doctor_id: data?.doctor_id,
  //   hospital_id: data?.hospital_id,
  //   patient_id: data?.patient_id,
  //   note: {
  //     additionalNotes: "",
  //     otherNotes: "",
  //   },
  //   ...selectedItem,
  // })
  const [formData, setFormData] = useState({});

  const fetchPreconsultData = async () => {
    try {
      setLoading(true);
      console.log("doctor id:", userData?.id);
      const result = await getPreconsultData(
        followUpAppointmentID ? followUpAppointmentID : appointmentID
      );

      if (result.success) {
        console.log("Formatted Data:", result);
        setData(result?.data);
        const initialSelectedItem = {
          symptoms: result?.data?.symptoms || [],
          findings: result?.data?.findings || [],
          diagnosis: result?.data?.diagnosis || [],
          medicines: result?.data?.medicines || [],
          investigations: result?.data?.investigations || [],
          instructions: result?.data?.instructions || [],
          procedures: result?.data?.procedures || [],
        };

        setFormData({
          ...result?.data,
          ...initialSelectedItem,
          print_html_view: followUpAppointmentID ? null : result?.data?.print_html_view,
          id: appointmentID,
          appointment_date: dayjs().format("YYYY-MM-DD"),
          appointment_time: dayjs().format("hh:mm A"),
        });
        setSelectedItem(initialSelectedItem);
        fetchCaseSheetData(result?.data?.patient?.id);
      } else {
        console.error("Error:", result.error || "Failed to fetch Appointments");
      }
    } catch (err) {
      console.error("Exception:", err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchCaseSheetData = async (patient_id) => {
    try {
      const result = await getCaseSheetData(patient_id);
      if (result.success) {
        setCaseSheetData(result?.data);
      } else {
        setCaseSheetData([]);

        console.error(
          "Error:",
          result.error || "Failed to fetch casesheet data"
        );
      }
    } catch (err) {
      setCaseSheetData([]);

      console.error("Exception:", err.message);
    }
  };
  useEffect(() => {
    fetchPreconsultData();
  }, [preconsultDataRefresh]);

  useEffect(() => {
    setCurrentItem(null);
    setCurrentItemRight(null);
  }, [step]);

  const addConsultantData = async () => {
    try {
      console.log("doctor id:", userData?.id);
      if (formData?.id) {
        const result = await addConsultData(formData);
        if (result.success) {
          console.log("auto saved:", result);
        } else {
          console.error(
            "Error:",
            result.error || "Failed to autosave consultant"
          );
        }
      }
    } catch (err) {
      console.error("Exception:", err.message);
    }
  };
  const changestatus = async (data) => {
    try {
      console.log("doctor id:", userData?.id);
      if (formData?.id) {
        const result = await addConsultData(data);
        if (result.success) {
          console.log("auto saved:", result);
        } else {
          console.error(
            "Error:",
            result.error || "Failed to autosave consultant"
          );
        }
      }
    } catch (err) {
      console.error("Exception:", err.message);
    }
  };
  // useEffect(() => {
  //   addConsultData()
  // }, [formData?.status])
  const autosave = async (value) => {
    if (value == "Hold") {
      console.log("Hold");
      setFormData((prev) => ({ ...prev, status: "Hold" }));
      const data = { ...formData, status: "Hold" };
      await changestatus(data);
      navigate("/doctor-dashboard");
    } 
    else if (value == "Lab_Report") {
      setFormData((prev) => ({ ...prev, status: "Lab_Report" }));
      const data = { ...formData, status: "Lab_Report" };
      await changestatus(data);
      navigate("/doctor-dashboard");
    }
    else addConsultantData();
  };
  // useEffect(() => {
  //   addConsultantData();
  // }, [formData.status]); // runs when status changes

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      ...selectedItem,
    }));
    console.log("Updated formData:", formData);
  }, [selectedItem]);

  const handleItemSelect = (sectionId, item) => {
    console.log(sectionId);
    if (
      sectionId == "symptoms" ||
      sectionId == "findings" ||
      sectionId == "medicines"
    )
      setCurrentItem(item);
    else if (sectionId == "instructions") setCurrentItemRight(null);
    
    else setCurrentItemRight(item);

    setCurrentSection(sectionId);

    const newSelectedItem = { ...selectedItem };
    const current = newSelectedItem[sectionId] || [];
    console.log("Current selected items:", current);

    const existingIndex = current.findIndex((i) => i.name === item.name);

    if (existingIndex !== -1) {
      // Item exists — update it
      newSelectedItem[sectionId] = [...current];
      setSelectedIteamFormData(
        formData?.[sectionId]?.find((i) => i.name === item.name) || {}
      );
      console.log("Updated selected items:", selectedIteamFormData);
    } else {
      // Item doesn't exist — add it
      newSelectedItem[sectionId] = [...current, item];
      setSelectedIteamFormData(item || {});
      console.log("Current selected items:", item);
    }

    setSelectedItem(newSelectedItem);
    console.log("New selected item:", selectedItem);
    return newSelectedItem;
  };

  const handleRemoveItem = (sectionId, itemId) => {
    const newSelectedItem = {
      ...selectedItem,
      [sectionId]: (selectedItem[sectionId] || []).filter(
        (i) => i.name !== itemId
      ),
    };
    setCurrentItem(null);
    setCurrentItemRight(null);
    setSelectedItem(newSelectedItem);
    return newSelectedItem;
  };

  const handleNoteChange = (updatedNote) => {
    setFormData((prev) => ({
      ...prev,
      ...updatedNote,
    }));
  };
  const navigate = useNavigate();
  const previewRx = () => {
    navigate("/preview-RX", { state: { formData: formData } });
  };

  // Responsive styles
  const containerStyle = {
    minHeight: "100vh",
    background: "#f5f5f5",
    padding: screens.xs ? "8px" : "16px",
  };

  const cardStyle = {
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    marginBottom: screens.xs ? "8px" : "16px",
  };

  const scrollableStyle = {
    maxHeight: "fullhight",
    overflowY: "auto",
    overflowX: "hidden",
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="dashboard-container">
          <div
            className="vh-100 d-flex flex-column"
            style={{
              overflow: "hidden",
              background: "#f5f5f5",
            }}
          >
            {/* Main Dashboard Card */}
            <div className="card h-100 d-flex flex-column shadow-sm border-0 mb-0">
              <div className="card-body p-0 d-flex flex-column overflow-hidden">
                <Container
                  fluid
                  className="p-0 h-100 d-flex flex-column"
                  style={{ position: "relative" }}
                >
                  {/* Main Content - Padded at bottom to make space for sticky header */}
                  <Row
                    className="m-0 flex-grow-1"
                    style={{
                      minHeight: 0,
                      paddingBottom: screens.xs ? "60px" : "70px",
                    }}
                  >
                    {/* Sidebar Column */}
                    {showSidebar && (
                      <Col
                        xs={4}
                        sm={4}
                        md={4}
                        lg={4}
                        xl={4}
                        className="p-0 border-2 border-end d-flex flex-column"
                        style={{
                          height: screens.xs ? "auto" : "100%",
                          maxHeight: screens.xs ? "50vh" : "100%",
                          background: "#fff",
                        }}
                      >
                        <div
                          className="h-100"
                          style={{
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column",
                            padding: screens.xs ? "8px" : "12px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "8px",
                            }}
                          >
                            <Button
                              type="button"
                              onClick={() => setShowSidebar(false)}
                              style={{
                                fontSize: "0.8rem",
                              }}
                            >
                              {showSidebar ? (
                                <MenuFoldOutlined />
                              ) : (
                                <MenuUnfoldOutlined />
                              )}
                            </Button>
                            {/* Toggle Button for SectionManager/SectionManager1 */}
                            {/* <Button
                              variant={
                                showSectionList ? "primary" : "outline-primary"
                              }
                              size="sm"
                              onClick={() =>
                                setShowSectionList((prev) => !prev)
                              }
                              style={{ marginLeft: "8px" }}
                            >
                              {showSectionList ? "Show Manager" : "Show List"}
                            </Button> */}
                          </div>
                          <PatientSidebar
                            vitals={vitalsData}
                            notes={{
                              prescription_notes:
                                formData.prescription_notes || "",
                              doctor_notes: formData?.doctor_notes || "",
                            }}
                            onNotesChange={handleNoteChange}
                            appointmentDetails={{
                              appointment_id: appointmentID,
                              patient_id: data?.patient_id,
                            }}
                            vitalRefresh={setVitalRefreshFlag}
                          />
                        </div>
                      </Col>
                    )}
                    {!showSidebar && (
                      <Col
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        className="p-0 d-flex flex-column  border-2"
                        style={{
                          height: screens.xs ? "auto" : "100%",
                          minHeight: screens.xs ? "50vh" : "100%",
                          background: "#fff",
                          flex: "0 0 3%",
                          maxWidth: "3%",
                        }}
                      >
                        <Button
                          type="button"
                          onClick={() => setShowSidebar(true)}
                          style={{
                            alignSelf: "flex-start",
                            margin: "8px",
                            fontSize: "0.8rem",
                          }}
                        >
                          <MenuUnfoldOutlined />
                        </Button>
                      </Col>
                    )}

                    {/* Section Manager Column */}
                    {(step == "Symptoms" || step== "Treatment") && (<><Col
                      xs={showSidebar ? 10 : 11}
                      sm={showSidebar ? 10 : 11}
                      md={showSidebar ? 16 : 20}
                      lg={showSidebar ? 10 : 12}
                      xl={showSidebar ? 10 : 12}
                      className="p-0 d-flex flex-column border-end border-2"
                      style={{
                        height: screens.xs ? "auto" : "100%",
                        minHeight: screens.xs ? "50vh" : "100%",
                        background: "#fff",
                      }}
                    >
                      <div
                        className="h-100"
                        style={{
                          overflow: "hidden",
                          display: "flex",
                          flexDirection: "column",
                          padding: screens.xs ? "8px" : "12px",
                        }}
                      >
                        {/* Conditionally render SectionManager or SectionManager1 */}

                        {currentItemRight &&
                        currentSection != "instructions" ? (
                          <DetailForm
                            type={currentSection}
                            title={currentItemRight}
                            onDataChange={handleDataChange}
                            formdata={selectedIteamFormData}
                            goToNextSection={goToNextSection}
                          />
                        ) : (
                          <SectionManager
                            activeSection1={currentactiveSection}
                            iteam={
                              step == "Symptoms"
                                ? ["symptoms", "findings"]
                                : ["medicines"]
                            }
                            sections={formData}
                            onItemSelect={handleItemSelect}
                            onIteamRemove={handleRemoveItem}
                            setShowSidebar={setShowSidebar}
                            autoSave={autosave}
                            refresh={(type) => {
                              setPreconsultDataRefresh((prev) => !prev),
                                setCurrentactiveSection(type);
                            }}
                            setSearchQuery1={setSearchQueryfun}
                            caseSheetData={caseSheetData}
                          />
                        )}
                      </div>
                    </Col>

                    {/* Detail Form Column */}
                    <Col
                      xs={showSidebar ? 10 : 11}
                      sm={showSidebar ? 10 : 11}
                      md={showSidebar ? 10 : 11}
                      lg={showSidebar ? 10 : 11}
                      xl={showSidebar ? 10 : 11}
                      className="p-0 d-flex flex-column"
                      style={{
                        height: screens.xs ? "auto" : "100%",
                        minHeight: screens.xs ? "50vh" : "100%",
                        background: "#fff",
                      }}
                    >
                      <div
                        className="h-100"
                        style={{
                          overflow: "hidden",
                          display: "flex",
                          flexDirection: "column",
                          padding: screens.xs ? "8px" : "12px",
                        }}
                      >
                        {currentItem &&
                        currentSection &&
                        currentSection != "instructions" ? (
                          <DetailForm
                            type={currentSection}
                            title={currentItem}
                            onDataChange={handleDataChange}
                            formdata={selectedIteamFormData}
                            goToNextSection={goToNextSection}
                          />
                        ) : (
                          // CASE 2: Render SectionManager when no item is selected AND step is "Symptoms"
                          <SectionManager
                            iteam={
                              step == "Symptoms"
                                ? ["diagnosis"]
                                : [
                                    "investigations",
                                    "instructions",
                                    "procedures",
                                  ]
                            }
                            activeSection1={currentactiveSection}
                            sections={formData}
                            onItemSelect={handleItemSelect}
                            onIteamRemove={handleRemoveItem}
                            setShowSidebar={setShowSidebar}
                            autoSave={autosave}
                            refresh={(type) => {
                              setPreconsultDataRefresh((prev) => !prev),
                                setCurrentactiveSection(type);
                            }}
                            setSearchQuery1={setSearchQueryfun}
                            caseSheetData={caseSheetData}
                          />
                        )}
                      </div>
                    </Col></>)}

                    {
                      step== "Vaccination" && (
                        <Col
                      xs={showSidebar ? 20 : 23}
                      sm={showSidebar ? 20 : 23}
                      md={showSidebar ? 20 : 23}
                      lg={showSidebar ? 20 : 23}
                      xl={showSidebar ? 20 : 23 }
                      className="p-0 d-flex flex-column"
                      style={{
                        height: screens.xs ? "auto" : "100%",
                        minHeight: screens.xs ? "50vh" : "100%",
                        background: "#fff",
                      }}
                    >
                      <div
                        className="h-100"
                        style={{
                          overflow: "hidden",
                          display: "flex",
                          flexDirection: "column",
                          
                        }}
                      >
                        <VaccineBoard/>
                      </div>
                      </Col>
                      )
                    }
                  </Row>

                  {/* Header (Now acting as a Sticky Footer) */}

                  <div
                    className="border-top border-2"
                    style={{
                      position: "fixed",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      zIndex: 1000,
                      background: "#fff",
                      padding: screens.xs ? "6px 20px" : "5px 20px",
                      boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    <Consultant_Header
                      patient={data?.patient || ""}
                      step={step}
                      setStep={setStep}
                      previewRx={previewRx}
                      autoSave={autosave}
                      refresh={() => setPreconsultDataRefresh((prev) => !prev)}
                    />
                  </div>
                </Container>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
